import React from 'react';
import { Tag } from '@indigo-ag/component-module';
import { AgFinancing, CreditThreshold, DecisionSheet } from '@indigo-ag/schema';
import { utils } from 'shared';

import i18next from 'core/i18n';

interface CreditApprovalDetailsProps {
  additionalLimit: DecisionSheet['additionalLimit'];
  tier?: CreditThreshold['tier'];
  phase2?: AgFinancing['phase2'];
}

export const CreditApprovalDetails: React.FunctionComponent<CreditApprovalDetailsProps> = ({
  additionalLimit,
  tier,
  phase2
}) => {
  const isEscalated = !!phase2?.escalatedAt;

  return additionalLimit !== undefined || tier || isEscalated ? (
    <div>
      {phase2?.approvedCreditAmount ? (
        <Tag
          label={`${i18next.t('approvedLimit')}: ${utils.currency.formatBrazilCurrency(phase2?.approvedCreditAmount)}`}
          variant="info"
          hideIcon
        />
      ) : null}
      {tier ? <Tag label={tier} variant="info" hideIcon /> : null}
      {additionalLimit ? (
        <Tag
          label={`${i18next.t('requestedLimit')}: ${utils.currency.formatBrazilCurrency(additionalLimit)}`}
          variant="info"
          hideIcon
        />
      ) : null}
      {isEscalated ? (
        <Tag label={utils.text.firstLetterUppercase(i18next.t('escalated'))} variant="tip" hideIcon />
      ) : null}
    </div>
  ) : null;
};
